import { Component, Inject, OnInit } from '@angular/core';
import { FnModalService } from 'foundation';
import { SearchHeaderModalComponent } from './search-header-modal/search-header-modal.component';
import { LandingComponent } from '../../landing/landing.component';

@Component({
  selector: 'search-header',
  templateUrl: './search-header.component.html',
  styleUrl: './search-header.component.scss'
})
export class SearchHeaderComponent implements OnInit {

  constructor(
    private fnModalSvcs: FnModalService,
    private landing : LandingComponent
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    
  }

  openSearchModal() {
    this.fnModalSvcs.openCustomModal(SearchHeaderModalComponent, {
      data: {
        menuData: this.landing.menuItemArray 
      },
      width:'500px'
    })
  }



 




}
